import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { McdClaimLineList } from '../mcdClaimLine/McdClaimLineList';
import { useRsrc } from '@/common/rsrc/RsrcContext';


export const McdClaimDetail = () => {
  
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'mcdClaimLine', label: 'Lines', content: <McdClaimLineList mcdClaimObj={entityObj}/>},
    { id: 'val', label: 'Validations', content: <ValList parentEntity="MCD_CLAIM" parentEntityId={entityObj.id} />}
  ];

  const submitToPymt = () => {
    rsrc.store('sc', 'CLAIM_PYMT_STORE_PLUGIN', { entity: 'MCD_CLAIM', id: entityObj.id});
  }

  const augButtons = (buttons) => {
    buttons.push(<TitleButton icon={fas.faHandHoldingUsd} toolTip="Submit to Payment" onClick={submitToPymt}/>);      
  }

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  )
}